import EventManager  from 'dd-event-manager';



export default class AbstractSegment {
  requireYear = false;
  name        = '';
  config      = null;



  _watchTimerId       = null;
  _watchBeforeValue   = null;
  _hideBeforeWatching = null;



  /**
   * getters
   */
  // get yearSuffix() { return this.requireYear ? this.context.year + '_' : '' }
  get key() { return this.createKey() }
  get isWatching() { return this.watchState === 'running' }
  get isWatchPausing() { return this.watchState === 'pausing' }
  get hasWatchListeners() { return this._ev._stacks.find(stack => { return stack.type === 'change' }) !== undefined }

  createKey(year = this.context.year) {
    const yearSuffix = this.requireYear ? year + '_' : '';
    return `${this.context.key}_${yearSuffix}${this.name}`;
  }


  /**
   * constructor
   */
  constructor(context) {
    this._ev        = new EventManager(this);
    this.context    = context;
    this.watchState = 'pending';

    this.context.on('show', () => {
      if (this._hideBeforeWatching === true) {
        this._startWatch();
      }
      this._hideBeforeWatching = null;
      this.watchState = 'pausing';
    });

    this.context.on('hide', () => {
      this._hideBeforeWatching = this.isWatching;
      this._stopWatch();
    });
  }



  /**
   * set config
   */
  setConfig(config) {
    this.config = config;
  }



  /**
   * erase
   */
  erase() {
    this.context.cookies.erase(this.key);
    if (typeof this.onEraseAfter === 'function') this.onEraseAfter();
    this._checkChangeValue();
  }



  /**
   * set watch handler
   */
  listen(cb, tag = null) {
    const eventMap = `change${tag ? '.' + tag : ''}`;
    this.on(eventMap, () => {
      cb(this);
    });
    this._startWatch();
  }



  /**
   * remove watch handler
   */
  stopListen(cb, tag = null) {
    const eventMap = `change${tag ? '.' + tag : ''}`;
    this.off(eventMap, cb);
    if (this.hasWatchListeners) this._stopWatch();
  }


  copyToAnotherYear(year) {
    if (!this.requireYear || year === this.context.year) return;
    const value = this._get();
    const key = this.createKey(year);
    if (!!value) {
      this.context.cookies.set(key, value);
    } else {
      this.context.cookies.erase(key);
    }
  }

  copyFromAnotherYear(year, {
    cancelWhenHasValue = false,
    onlyCookie = false,
  }) {
    if (
      !this.requireYear
      || year === this.context.year
      || (cancelWhenHasValue && this._get(null) !== null)
    ) return;
    const key = this.createKey(year);
    const value = this.context.cookies.get(key);
    if (onlyCookie) {
      if (!!value) {
        this.context.cookies.set(this.key, value);
      } else {
        this.context.cookies.erase(this.key);
      }
    } else {
      this._set(value);
    }
  }



  /**
   * set cookie string
   */
  _set(value) {
    this.context.cookies.set(this.key, value);
    this._checkChangeValue();
  }



  /**
   * get cookie string
   */
  _get(defaultValue) {
    const value = this.context.cookies.get(this.key);
    return (value === null || value === undefined) ? defaultValue : value;
  }



  /**
   * check change value
   */
  _checkChangeValue() {
    const nowValue = this._get();
    if (this._watchBeforeValue !== nowValue) {
      this.emit('change', this);
      this._watchBeforeValue = nowValue;
    }
  }



  /**
   * watch ticker
   */
  _watchTick() {
    this._watchTimerId = setTimeout(() => {
      this._checkChangeValue();
      this._watchTick();
    }, this.context.watchInterval);
  }



  /**
   * start watch
   */
  _startWatch() {
    if (this.isWatching) return;
    if (this.isWatchPausing) {
      this._hideBeforeWatching = true;
      return;
    }
    this._clearWatchTimer();
    this._watchTick();
    this.watchState = 'running';
  }



  /**
   * stop watch
   */
  _stopWatch() {
    if (!this.isWatching) return;
    this._clearWatchTimer();
    // this._watchBeforeValue = null;
    this.watchState = 'pending';
  }



  /**
   * clear watch timer
   */
  _clearWatchTimer() {
    if (this._watchTimerId !== null) {
      clearTimeout(this._watchTimerId);
    }
    this._watchTimerId = null;
  }
}



// WEBPACK FOOTER //
// ./src/shared/bc-segments/segments/AbstractSegment.js